import * as Yup from 'yup';
const emailYup = Yup.string()
  .email("Enter valid Email")
  .min(8, 'Atleast 8 characters')
  .max(32, 'Only 32 characters are allowed')
  .required('Email is required');

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const phoneYup = Yup.string()
  .required('Mobile number is required')
  .matches(phoneRegExp, 'Mobile number is invalid')
  .min(10, 'Mobile number should be of 10 digits')
  .max(10, 'Mobile number should be of 10 digits');

const name = /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/;

const fullNameYup = Yup.string()
  .min(3, 'Atleast 3 characters')
  .max(32, 'Only 32 characters are allowed')
  .required('Name is required')
  .matches(name, 'Enter Valid Name');

  const firstNameYup = Yup.string()
  .min(3, 'Atleast 3 characters')
  .max(32, 'Only 32 characters are allowed')
  .required('First Name is required')
  .matches(name, 'Enter Your First Name');

  const lastNameYup = Yup.string()
  .min(3, 'Atleast 3 characters')
  .max(32, 'Only 32 characters are allowed')
  .required('Last Name is required')
  .matches(name, 'Enter Your Last Name');

  const positionYup = Yup.string()
  .min(3, 'Atleast 3 characters')
  .max(32, 'Only 32 characters are allowed')
  .required('Position is required')
  .matches(name, 'Enter Valid Position');

  const linkedInYup = Yup.string();

const FILE_SIZE = 160 * 1024;
const SUPPORTED_FORMATS = [
  "application/pdf",
];

const uploadResumeYup = Yup.mixed().required('A file is required').test(
  "fileFormat",
  "Unsupported Format",
  value => {
    console.log(value)
    return value && SUPPORTED_FORMATS.includes(value.type)
  }
)
  .test(
    "fileSize",
    "File too large",
    value => {
      console.log(value)
      return value && value.size <= FILE_SIZE;
    }
  )
export {
  emailYup, phoneYup, fullNameYup, uploadResumeYup, firstNameYup, lastNameYup, positionYup, linkedInYup,
}


export interface InfoMessage { message?: string; status?: number }

export const headers = {
  'Content-Type': 'application/json'
}
